// Re:Focus — Search Module
// Search modal, inline search bar, ⌘K keyboard shortcut

import { e } from './utils.js';

let _getBoardData = () => null;
let _mergeOverrides = (data) => data;
let _loadOverrides = () => ({});
let _renderFromState = () => {};
let _navToCard = (card, path) => {};
let _trapFocus = () => () => {};
let _activeFocusTrapRef = { value: null };
let _focusTrapTriggerRef = { value: null };

export function initSearch({ getBoardData, mergeOverrides, loadOverrides, renderFromState, navToCard, trapFocus, activeFocusTrapRef, focusTrapTriggerRef }) {
  _getBoardData = getBoardData;
  _mergeOverrides = mergeOverrides;
  _loadOverrides = loadOverrides;
  _renderFromState = renderFromState;
  _navToCard = navToCard;
  _trapFocus = trapFocus;
  _activeFocusTrapRef = activeFocusTrapRef;
  _focusTrapTriggerRef = focusTrapTriggerRef;
}

export function openSearch() {
  if (!_getBoardData()) return;
  const wrap = document.getElementById('search-wrap');
  const field = document.getElementById('search-expand');
  if (wrap.classList.contains('open')) {
    // Already open — open full modal with current query
    _focusTrapTriggerRef.value = document.activeElement;
    const q = field.value.trim();
    document.getElementById('search-input').value = q;
    document.getElementById('search-results').innerHTML = '';
    if (q) runSearch(q);
    const modal = document.getElementById('search-modal');
    modal.classList.remove('hidden');
    setTimeout(() => document.getElementById('search-input').focus(), 50);
    if (_activeFocusTrapRef.value) _activeFocusTrapRef.value();
    _activeFocusTrapRef.value = _trapFocus(modal);
    return;
  }
  wrap.classList.add('open');
  field.value = '';
  setTimeout(() => field.focus(), 50);
}

export function closeSearch() {
  document.getElementById('search-modal').classList.add('hidden');
  const wrap = document.getElementById('search-wrap');
  const field = document.getElementById('search-expand');
  wrap.classList.remove('open');
  field.value = '';
  if (_activeFocusTrapRef.value) { _activeFocusTrapRef.value(); _activeFocusTrapRef.value = null; }
  if (_focusTrapTriggerRef.value) { _focusTrapTriggerRef.value.focus(); _focusTrapTriggerRef.value = null; }
}

function runSearch(q) {
  const boardData = _getBoardData();
  const results = document.getElementById('search-results');
  if (!q.trim()) { results.innerHTML = ''; return; }
  const data = _mergeOverrides(boardData);
  const hits = [];
  const lower = q.toLowerCase();
  const ov = _loadOverrides();
  function searchCards(cards, colName, path) {
    for (const card of cards) {
      if (card.archived) continue;
      const nameMatch = card.name.toLowerCase().includes(lower);
      const taskMatch = (card.tasks || []).some(t => t.text.toLowerCase().includes(lower));
      const scopeMatch = (card.outcome || '').toLowerCase().includes(lower);
      const commsMatch = (card.comms || []).some(c => c.text?.toLowerCase().includes(lower));
      const progressMatch = (ov.cardProgressNotes?.[card.id] || '').toLowerCase().includes(lower);
      if (nameMatch || taskMatch || scopeMatch || commsMatch || progressMatch) {
        hits.push({ card, colName, path: [...path] });
      }
      if (card.children?.length > 0) searchCards(card.children, colName, [...path, card.name]);
    }
  }
  for (const col of data.columns) searchCards(col.projects, col.name, [col.name]);
  if (hits.length === 0) {
    results.innerHTML = '<div class="search-empty">No results</div>';
    return;
  }
  results.innerHTML = hits.slice(0, 12).map((h, i) =>
    `<button class="search-result-row" data-idx="${i}">
      <span class="search-result-path">${e(h.path.join(' › '))}</span>
      <span class="search-result-name">${e(h.card.name)}</span>
    </button>`
  ).join('');
  results.querySelectorAll('.search-result-row').forEach((row, i) => {
    row.addEventListener('click', () => {
      const { card, path } = hits[i];
      closeSearch();
      _navToCard(card, path);
    });
  });
}

export function setupSearchListeners() {
  document.getElementById('search-modal').addEventListener('click', ev => { if (ev.target.id === 'search-modal') closeSearch(); });
  document.getElementById('search-input').addEventListener('input', ev => runSearch(ev.target.value));
  document.getElementById('search-input').addEventListener('keydown', ev => { if (ev.key === 'Escape') closeSearch(); });
  document.getElementById('search-btn').addEventListener('click', openSearch);
  document.getElementById('search-expand').addEventListener('keydown', ev => {
    if (ev.key === 'Escape') { closeSearch(); return; }
    if (ev.key === 'Enter') {
      const q = ev.target.value.trim();
      if (q) {
        document.getElementById('search-input').value = q;
        document.getElementById('search-results').innerHTML = '';
        document.getElementById('search-modal').classList.remove('hidden');
        runSearch(q);
        setTimeout(() => document.getElementById('search-input').focus(), 50);
      }
    }
  });
  document.getElementById('search-expand').addEventListener('blur', () => {
    // Close inline field if empty and focus left
    setTimeout(() => {
      if (!document.getElementById('search-expand').value) closeSearch();
    }, 150);
  });
  document.addEventListener('keydown', ev => {
    if ((ev.metaKey || ev.ctrlKey) && ev.key === 'k') { ev.preventDefault(); openSearch(); }
  });
}
